<template>
  <div class="container">
    <div class="pcinfo">
      <div class="tits">{{ `${$t('msgbank').bankCard}${$t('with').title}` }}</div>
      <div class="form">
        <div>{{ $t('with').tbsl }}：</div>
        <van-field v-model="Amount" type="number" />
        <p style="font-size: 12px; color: #b3adad">
          {{ $t('with').ky }}：{{ getBalance() }} {{ type }}
        </p>
        <div>{{ $t('with').zjmm }}：</div>
        <van-field v-model="CashPassword" type="password" />

        <div class="tips">
          <p>
            {{ $t('with').sxf }}：<br />
            {{ userInfo.Charge }}%
          </p>
          <p class="num">
            {{ $t('with').dz }}： <br />
            <span>{{ getAmount() }} {{ type }}</span>
          </p>
        </div>
      </div>

      <van-button class="btn" type="info" round block color="#f2ba18" @click="handleSub">{{ $t('public').submit
        }}</van-button>
    </div>
  </div>
</template>

<script>
import transactionApi from '@/api/transaction'
import userApi from '@/api/user'
export default {
  components: {
  },
  data() {
    return {
      addr: '',
      CashPassword: '',
      type: 'USDT',
      active: 0,
      Amount: null,
      userInfo: {
        CoinAmountInfo: {}
      },
      list: ['ERC20', 'TRC20', 'OMNI']
    }
  },
  mounted() {
    this.getUserInfo()
  },
  methods: {
    getAmount() {
      return ((100 - this.userInfo.Charge) * this.Amount) / 100
    },
    getBalance() {
      return this.userInfo.LegalAmountInfo[this.type]
    },
    async getUserInfo() {
      this.userInfo = await userApi.userInfo()
      //银行卡绑定判断
      if (!this.userInfo.IsBindBank) {
        this.$dialog
          .confirm({
            confirmButtonText: this.$t('msgbank').noBindBankBtn,
            cancelButtonText: this.$t('public').cancel,
            title: this.$t('msgbank').noBindBankmsg
          })
          .then(() => {
            this.$router.push({ name: 'Bank' })
          })
          .catch(() => {
            this.$router.go(-1)
          })
      }
    },
    async handleSub() {
      if (!this.Amount) {
        this.$toast(this.$t('with').tips1)
        return false
      }

      if (this.CashPassword === '') {
        this.$toast(this.$t('with').tip2)
        return false
      }
      const form = {
        Type: 'bank',
        Amount: Number(this.Amount),
        CashPassword: this.CashPassword
      }
      await transactionApi.lower(form)
      this.$toast(this.$t('moneyAddr').success)
      setTimeout(() => {
        this.$router.push({ name: 'Home' })
      }, 1000)
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding: 50px 0;
  width: 100%;

  .pcinfo {
    margin: 0 auto;
    max-width: 700px;
  }

  .tits {
    font-size: 20px;
    font-weight: bold;
  }

  .form {
    margin: 20px 0;
    border-radius: 4px;
    background: #17181e;
    padding: 15px;

    div {
      font-size: 14px;
      margin: 10px 0;
    }

    .addrType {
      margin-bottom: 10px;
      display: flex;

      .item {
        width: 100px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #dddde9;
        color: #333;
        border-radius: 4px;
        margin: 0 10px;
      }

      .active {
        background: #fff;
        color: #f2ba18;
        border: 1px solid #f2ba18;
      }
    }

    .van-field {
      border-radius: 5px;
    }

    .tips {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      line-height: 1.2;

      span {
        font-weight: bold;
        color: #f2ba18;
        font-size: 16px;
      }
    }
  }

  .btn {
    margin: 30px auto 0;
    width: 100%;
  }
}
</style>
